// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-08T21:34:03.539Z
// Property: Sundance (ID: 6767906449166813)
// Collections: 22 amenities, 5 floorplans (live), 22 photos, 40 POIs, 6 reviews, 3 virtual tours, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166813",
  "property_external_id": "nrsv1cm",
  "property_zillow_url": "https://www.zillow.com/apartments/milton-wa/sundance/5XjKPZ/",
  "property_apartments_url": "https://www.apartments.com/sundance-milton-wa/nrsv1cm/",
  "property_google_business_url": "https://www.google.com/maps/place/Sundance/data=!4m2!3m1!1s0x0:0xc63873fb39ff90f9?sa=X&ved=2ahUKEwjTwKXN6KeSAxVyOEQIHa--MWcQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "2756601004",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "176SUD",
  "property_status": null,
  "property_slug": "sundance",
  "property_name": "Sundance",
  "property_website_url": "https://www.sundance-apartments.com/",
  "property_domain": "https://www.sundance-apartments.com/",
  "property_address": "210 27th Avenue",
  "property_full_address": "210 27th Ave, Milton, WA 98354, USA",
  "property_address_1": "210 27th Avenue",
  "property_address_2": null,
  "property_address_city": "Milton",
  "property_address_state": "WA",
  "property_address_zip_full": null,
  "property_address_zip": "98354",
  "property_address_country": "US",
  "property_address_county": "Pierce County",
  "property_neighborhood_address": "Outlying Puyallup",
  "property_address_latitude": "47.2570324",
  "property_address_longitude": "-122.2976158",
  "property_email": null,
  "property_phone": "(253) 243-0650",
  "property_call_tracking_phone": "855-481-4346",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome home to Sundance in Milton, WA, where comfort meets convenience. Choose from one, two, or three-bedroom floor plans, and indulge in top-notch amenities like a sparkling pool, state-of-the-art fitness center, and tranquil dog park. Embrace a lifestyle of relaxation and connection—your new adventure awaits!",
  "property_long_description": "Welcome to Sundance, your ideal apartment community located in the heart of Milton, WA. Our spacious floor plans offer a variety of options to fit your lifestyle, including stylish one-bedroom, two-bedroom, and three-bedroom layouts. Embrace the relaxed atmosphere and modern comforts that make Sundance the perfect place to call home.\n\nAt Sundance, we take pride in our exceptional amenities designed for your convenience and enjoyment. Dive into our shimmering pool on sunny days, maintain your fitness goals in our fully-equipped fitness center, or unwind in our relaxing hot tub and spa. Families will appreciate our children's playground and expansive dog park, while our well-maintained walking and biking trails invite you to explore the beauty of our landscaped community.\n\nWe understand the importance of community and connection, which is why we offer a welcoming clubhouse, community-wide WiFi, and a reliable package service to make your life easier. Additional features like on-site maintenance, recycling, and a renters insurance program ensure your needs are met.\n\nEach apartment home is thoughtfully designed with modern finishes, including quartz countertops, walk-in closets, washer/dryer units, and much more. Enjoy cozy evenings by the fireplace or take in scenic views from your private balcony or patio.\n\nDiscover the serene lifestyle that awaits you at Sundance. Explore our available apartments or schedule a tour today to experience all the comforts and conveniences of our community! Your new home awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019f387b-30c0-71c3-bae2-d97f36810ed7.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior of the apartment building's main entrance and office.",
    "public_id": "019f387b-30c0-71c3-bae2-d97f36810ed7",
    "storage_key": "property/6767906449166813/019f387b-30c0-71c3-bae2-d97f36810ed7.webp",
    "width": 3072,
    "height": 2049
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "105",
  "property_year_built": "2003",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.23809523809523",
  "property_admin_fee": "300",
  "property_application_fee": "70",
  "property_fees_deposit_info": "$500- 1 Months Rent",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "1",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Maximum of 2 pets per unit.",
  "property_pet_policy_description": "Cats and dogs are allowed with no weight limit. Pet deposit: $300 (refundable); pet fee: $200 (non‑refundable); monthly pet rent: $50. Maximum of 2 pets per unit.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://www.myrentalapplication.com/index/amcsundance",
  "property_resident_portal_url": "https://sundancewa.goprisma.com/auth/login",
  "property_apply_now_url": "https://myrentalapplication.com/index/amcsundance",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d20b8-2d18-70cc-b374-806ff755c3aa.webp",
  "property_primary_logo_media": {
    "alt_text": "Sundance logo",
    "public_id": "019d20b8-2d18-70cc-b374-806ff755c3aa",
    "storage_key": "property/6767906449166813/019d20b8-2d18-70cc-b374-806ff755c3aa.webp",
    "width": 277,
    "height": 88
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d20b8-36c8-70cd-b85c-861a5e911a93.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Sundance logo",
    "public_id": "019d20b8-36c8-70cd-b85c-861a5e911a93",
    "storage_key": "property/6767906449166813/019d20b8-36c8-70cd-b85c-861a5e911a93.webp",
    "width": 277,
    "height": 88
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d20b8-3efe-756f-be10-fd55ea08dff3.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Sundance logo",
    "public_id": "019d20b8-3efe-756f-be10-fd55ea08dff3",
    "storage_key": "property/6767906449166813/019d20b8-3efe-756f-be10-fd55ea08dff3.webp",
    "width": 277,
    "height": 88
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#111111",
  "property_secondary_color": "#A1563D",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "725 - 950,985 sq ft",
  "property_sqft_min": "725",
  "property_sqft_max": "1160",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": "2570",
  "property_available_units": 5,
  "property_facebook_url": "https://www.facebook.com/Sundance.Apartments.WA/",
  "property_instagram_url": "https://www.instagram.com/sundanceaptswa/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJZw6oV5f5kFQR-ZD_OftzOMY",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?cflt=apartments&find_loc=Edgewood%2C+WA",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Sundance",
  "property_home_romance_title": "Embrace a New Lifestyle in Your Perfect Apartment Home",
  "property_home_amenities_blurb": "At Sundance in Milton, WA, you'll find your perfect apartment retreat. Choose from one, two, or three-bedroom floor plans that blend comfort with style. Enjoy premier amenities like a sparkling pool, fitness center, and serene walking trails, all designed to enhance your lifestyle. Your new home awaits!",
  "property_home_floorplans_blurb": "At Sundance in Milton, WA, experience the ideal blend of comfort and style with our thoughtfully designed floor plans. Each apartment home is crafted to elevate your living experience, offering spacious layouts and modern finishes. Browse our available options today and uncover the perfect space that suits your lifestyle!",
  "property_home_gallery_blurb": "Welcome to Sundance in Milton, WA, where comfort meets convenience. Choose from our spacious one, two, and three-bedroom floor plans, and indulge in resort-style amenities like a shimmering pool, state-of-the-art fitness center, and serene walking trails. Picture yourself living here—your dream home awaits!",
  "property_home_neighborhood_blurb": "At Sundance in Milton, WA, immerse yourself in a vibrant neighborhood filled with diverse attractions. From parks like Steel Lake and Game Farm to cultural gems like the Pacific Bonsai Museum, your new home offers endless adventures. Uncover the perfect blend of comfort and community right outside your door.",
  "property_home_reviews_blurb": "Welcome to Sundance in Milton, WA, where residents rave about our “spacious layouts and friendly community.” Experience the perfect blend of comfort and convenience in a vibrant setting. Don’t just take our word for it—see what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At Sundance in Milton, WA, your home is surrounded by vibrant local attractions and lush parks. Dive into nature at Steel Lake Park or unleash your adventurous spirit at Catapult Adventure Park. With the Federal Way Memorial Field and the Pacific Bonsai Museum nearby, you’ll never run out of enriching experiences. See what's around our community!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Sundance in Milton, WA, your ideal home awaits among stunning one, two, and three-bedroom floor plans. Dive into luxury with resort-style amenities like a sparkling pool, a relaxing hot tub, and lush walking trails. Experience comfort and convenience tailored just for you—your sanctuary is calling!",
  "property_applynow_blurb": "At Sundance in Milton, WA, your ideal home awaits with spacious one, two, and three-bedroom floor plans designed for modern living. Dive into a wealth of amenities, from a sparkling pool and fitness center to scenic walking trails. Embrace comfort and convenience—apply online today to make Sundance your new haven!",
  "property_contactus_blurb": "At Sundance in Milton, WA, we offer a variety of thoughtfully designed floor plans, from cozy one-bedroom retreats to spacious three-bedroom havens. Each apartment is crafted for comfort and style. Have questions? Reach out to our friendly leasing team today and let us help you find your perfect home!",
  "property_faqs_blurb": "At Sundance in Milton, WA, we offer a range of thoughtfully designed floor plans—one, two, and three bedrooms—to suit your lifestyle. Curious about our community? Visit our FAQs page to uncover everything you need to know and make your move to Sundance an informed one!",
  "property_floorplans_blurb": "At Sundance in Milton, WA, each apartment home is thoughtfully designed to suit your lifestyle. Choose from spacious one, two, or three-bedroom floor plans that blend comfort and style seamlessly. Browse our available units today and find the ideal space to create your vibrant new life.",
  "property_gallery_blurb": "At Sundance in Milton, WA, picture yourself basking by the shimmering pool, unwinding in the spa, or hosting friends in your stylish apartment. Choose from spacious one, two, or three-bedroom floor plans and enjoy amenities like a dog park, clubhouse, and gorgeous walking trails. Your dream lifestyle awaits!",
  "property_interactivemap_blurb": "Welcome to Sundance in picturesque Milton, WA! Whether you seek a cozy one-bedroom or a spacious three-bedroom, our thoughtfully designed floor plans cater to every lifestyle. Enjoy resort-style amenities like a sparkling pool, dog park, and walking trails, all while utilizing our interactive community map to find your ideal home!",
  "property_pets_blurb": "At Sundance in Milton, WA, your furry friends are part of the family! With no weight limit and a welcoming atmosphere, enjoy spacious living alongside your pets. Relish in the convenience of nearby parks while embracing comfort. Experience a community where both you and your pets can thrive!",
  "property_referafriend_blurb": "At Sundance in Milton, WA, our vibrant community thrives on connection and camaraderie. With spacious one, two, and three-bedroom floor plans, your ideal home awaits. Great friends make great neighbors—refer a friend today and elevate your living experience together in a place filled with comfort and style!",
  "property_residentaccess_blurb": "Welcome to Sundance in Milton, WA, where comfort meets convenience. Choose from our thoughtfully designed one, two, or three-bedroom floor plans to suit your lifestyle. Access your resident portal to effortlessly manage rent, schedule maintenance, and stay connected with community updates. Your ideal home awaits!",
  "property_reviews_blurb": "At Sundance in Milton, WA, residents rave about their vibrant community, with one stating, “Living here feels like home!” Experience the warmth and camaraderie that define our apartments. See what our residents have to say about living at our community—and why they love calling Sundance home!",
  "property_created_at": "1762201615131",
  "property_scheduletour_blurb": "At Sundance in Milton, WA, our thoughtfully designed floor plans—offering one, two, and three-bedroom options—cater to all lifestyles. Experience the vibrant community that feels like home. Curious? Schedule a tour and see what our residents love most about their Sundance living experience!",
  "property_thankyou_blurb": "Thank you for your interest in Sundance, where stylish living meets serene surroundings in Milton, WA. Our diverse floor plans, ranging from one to three bedrooms, cater to your ideal lifestyle. A team member will reach out soon to help you find your perfect home!",
  "property_virtualtours_blurb": "Experience the vibrant lifestyle at Sundance in Milton, WA, where comfort meets style. With meticulously designed one, two, and three-bedroom apartments, each space reflects modern living. Ready to envision your future home? Take a virtual tour today and step into the community that speaks to your soul!",
  "property_copyright": "2025 All Rights Reserved. Sundance",
  "property_seo_title_home": "Sundance |  Apartments in Milton, WA",
  "property_seo_description_home": "Experience comfort and style at Sundance in Milton, WA! Choose from one to three-bedroom apartments with luxurious amenities. Your perfect home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Milton, WA Apartments for Rent",
  "property_seo_description_floorplans": "Find your perfect match at Sundance in Milton, WA! Choose from one, two, or three-bedroom floor plans tailored for your lifestyle. Browse now!",
  "property_seo_title_amenities": "Amenities | Milton, WA Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury at Sundance in Milton, WA. Enjoy a pool, fitness center, dog park, and modern apartments with quartz countertops.",
  "property_seo_title_gallery": "Gallery | Apartments in Milton, WA",
  "property_seo_description_gallery": "Imagine vibrant living at Sundance in Milton, WA! From stunning floor plans to top-notch amenities, your dream home awaits. View our photo gallery now!",
  "property_seo_title_virtualtours": "Virtual Tours | Sundance Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Sundance in Milton, WA! Take a virtual tour of our one, two, and three-bedroom apartments—your perfect home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Sundance Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Sundance in Milton, WA! Explore spacious floor plans, luxury amenities, and a vibrant community with our interactive map.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Milton, WA",
  "property_seo_description_neighborhood": "Uncover Milton's vibrant life around Sundance! Check out local favorites, parks, and dining spots near our one, two, and three-bedroom apartments.",
  "property_seo_title_contact": "Contact Us | Sundance",
  "property_seo_description_contact": "Connect with Sundance in Milton, WA! From one to three-bedroom options, your perfect home awaits. Reach out to our leasing team for any inquiries!",
  "property_seo_title_faqs": "FAQs | Apartments in Milton, WA",
  "property_seo_description_faqs": "Get insights into life at Sundance in Milton, WA! Our FAQs cover everything from amenities to floor plans. Join our welcoming community today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Milton, WA",
  "property_seo_description_reviews": "At Sundance in Milton, WA, our residents thrive! Check out their reviews and discover the vibrant lifestyle enjoyed in our welcoming community. Join us!",
  "property_seo_title_applynow": "Apply Now | Apartments in Milton, WA",
  "property_seo_description_applynow": "Experience modern living at Sundance in Milton, WA! Enjoy spacious floor plans, top-notch amenities, and a vibrant community. Lease your ideal home today!",
  "property_seo_title_residentaccess": "Resident Access | Sundance",
  "property_seo_description_residentaccess": "Connect to Sundance's resident portal in Milton, WA. Pay rent, request maintenance, and manage your home effortlessly—all in one place!",
  "property_seo_title_referafriend": "Refer A Friend | Sundance",
  "property_seo_description_referafriend": "Refer a friend to Sundance in Milton, WA, and enjoy a vibrant community with fun, connections, and unforgettable moments! ",
  "property_seo_title_scheduletour": "Schedule a Tour | Sundance",
  "property_seo_description_scheduletour": "Experience the vibrant lifestyle at Sundance in Milton, WA. Schedule your tour today and witness your future home filled with comfort and community!",
  "property_seo_title_privacy": "Privacy Policy | Sundance",
  "property_seo_description_privacy": "At Sundance in Milton, WA, your privacy matters. Learn how we protect your information and ensure peace of mind while you enjoy vibrant community living.",
  "property_seo_title_accessibility": "Website Accessibility | Sundance",
  "property_seo_description_accessibility": "At Sundance in Milton, WA, we prioritize accessibility for all. Join us in creating an inclusive community where everyone feels at home. Learn more today!",
  "property_seo_title_sitemap": "Sitemap | Sundance",
  "property_seo_description_sitemap": "Navigate your way to your perfect home at Sundance in Milton, WA. Check out our sitemap for easy access to all the community features and amenities!",
  "property_seo_title_thankyou": "Thank You | Sundance",
  "property_seo_description_thankyou": "Thank you for reaching out to Sundance in Milton, WA! A team member will be in touch soon to help you discover your perfect new home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Milton, WA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293630514",
  "amenities": [
    {
      "id": "custom_dbe33223-4a37-4aee-a07f-1cb088c283b2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "external_id": "false",
      "title": "High Speed Internet",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_82950fce-9dc0-4412-8e15-20ec1f92287e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "external_id": "false",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_97d09dae-9806-4b87-b1b9-7657d8cea479",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "external_id": "false",
      "title": "Spa/Hot Tub",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c5345092-15f3-4a03-9267-d024ae341c45",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3e244594-e6ff-4513-9fb9-b1feadc90e9a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "external_id": "false",
      "title": "Covered Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1cb92bd9-3333-4b1b-8f49-c37af8ed9c5c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "external_id": "false",
      "title": "Package Receiving",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_96704095-6b27-48af-8fb3-283cd66223a2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_66d626e2-3b9a-481e-b79b-9468feafd131",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "external_id": "false",
      "title": "Garages Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f75e1806-d56e-4f4e-be2b-2049b3dc26a0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5bb5c91c-3554-44bf-b052-3251d7008d5e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "external_id": "false",
      "title": "Free Weights",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4eea671f-3f38-4c2d-9fb9-06252c688f00",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0e01e7ba-172b-48bd-8396-6d1765a314a5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "external_id": "false",
      "title": "Fully Equipped Kitchen",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_432fc519-9fe6-44ab-84a4-a0524f9f4004",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "external_id": "false",
      "title": "Full Size Washer & Dryer",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_caead0f7-3420-4462-935b-ee0ad3814c10",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "external_id": "false",
      "title": "Fireplace",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2e69df2d-5e5a-4e7c-a254-25773d55a5dd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "external_id": "false",
      "title": "Views",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_335019ee-6f84-494f-b3bd-a883741c6a2b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_da980c97-e9b2-4b45-b4e3-cb0ea938744a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "external_id": "false",
      "title": "Carpeting",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b0093d62-83a4-423b-957e-161e1697e20a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "external_id": "false",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_17d8bf2c-763c-45ec-8318-714f845c7f1f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "external_id": "false",
      "title": "High Ceilings",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_35b5f5eb-26f7-4e50-8f3e-57e944b80edf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "external_id": "false",
      "title": "Vinyl Plank Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0481991e-3980-466b-af78-98829ff17b67",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_94effe13-651a-4f9f-a7c5-43d7132d6be2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_ace3e361-c99b-42ee-9789-15f0eeb67244",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019f387a-9163-722b-af2c-4aef7b796f05.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel sink, black refrigerator, stove, and microwave.",
        "public_id": "019f387a-9163-722b-af2c-4aef7b796f05",
        "storage_key": "property/6767906449166813/019f387a-9163-722b-af2c-4aef7b796f05.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring a stainless steel sink, ample cabinet space, a black refrigerator, stove, and microwave for your culinary needs.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel sink, black refrigerator, stove, and microwave.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_75ca6c73-56da-432b-8916-ba8e06ff60d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019f387b-42ce-726a-8f5c-2276ef015926.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel sink, black stove, microwave, and refrigerator.",
        "public_id": "019f387b-42ce-726a-8f5c-2276ef015926",
        "storage_key": "property/6767906449166813/019f387b-42ce-726a-8f5c-2276ef015926.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring light wood cabinetry, a double basin sink, and black appliances including a stove, microwave, and refrigerator.",
      "link": "",
      "alt_text": "Kitchen with stainless steel sink, black stove, microwave, and refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0969ee08-bd52-48c0-ad79-189810205473",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019f3879-f840-7322-bc50-cd29dca3067b.webp",
      "image_media": {
        "alt_text": "Living room with a gas fireplace and a dining area leading to a patio.",
        "public_id": "019f3879-f840-7322-bc50-cd29dca3067b",
        "storage_key": "property/6767906449166813/019f3879-f840-7322-bc50-cd29dca3067b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a gas fireplace, perfect for relaxing evenings. The adjacent dining area offers access to a patio and seamlessly connects to the kitchen.",
      "link": "",
      "alt_text": "Living room with a gas fireplace and a dining area leading to a patio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_25b8c703-f177-4bed-a027-b12cb6e496ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019f3879-fce8-70ab-8523-7ace3dbeeaa2.webp",
      "image_media": {
        "alt_text": "Kitchen area with a fireplace and a balcony door.",
        "public_id": "019f3879-fce8-70ab-8523-7ace3dbeeaa2",
        "storage_key": "property/6767906449166813/019f3879-fce8-70ab-8523-7ace3dbeeaa2.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring a double sink, dishwasher, and breakfast bar, adjacent to a living area with a fireplace and access to a balcony.",
      "link": "",
      "alt_text": "Kitchen area with a fireplace and a balcony door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_699c1979-6be2-4e33-8167-17fe844f8bb8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d48ac-9bc5-7704-af8a-fec0c54c72a8.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, closet, and window.",
        "public_id": "019d48ac-9bc5-7704-af8a-fec0c54c72a8",
        "storage_key": "property/6767906449166813/019d48ac-9bc5-7704-af8a-fec0c54c72a8.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a plush queen-size bed, ample closet space, and a large window with natural light.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, closet, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fe5f8ac2-e42a-4477-a1fd-c01d28274829",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d3-4bf8-73b9-99e1-c61051372494.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a king-size bed, nightstands, shelving, and decorative art.",
        "public_id": "019d02d3-4bf8-73b9-99e1-c61051372494",
        "storage_key": "property/6767906449166813/019d02d3-4bf8-73b9-99e1-c61051372494.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom, featuring a plush king-size bed, modern decor, and ample storage.",
      "link": "",
      "alt_text": "Modern bedroom with a king-size bed, nightstands, shelving, and decorative art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e86ce5c6-c0de-4c8f-9772-e615fcfb09cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d3-4265-717c-b76a-d314a8202d87.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen in a modern apartment",
        "public_id": "019d02d3-4265-717c-b76a-d314a8202d87",
        "storage_key": "property/6767906449166813/019d02d3-4265-717c-b76a-d314a8202d87.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious dining area adjacent to a modern kitchen, perfect for entertaining and everyday living.",
      "link": "",
      "alt_text": "Dining area and kitchen in a modern apartment",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_074ac242-7d9d-4d94-8827-1d3bbfb3f2fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d3-41c5-774c-9d27-739fe7d8eb38.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, fireplace, and TV.",
        "public_id": "019d02d3-41c5-774c-9d27-739fe7d8eb38",
        "storage_key": "property/6767906449166813/019d02d3-41c5-774c-9d27-739fe7d8eb38.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a modern sectional sofa, a cozy fireplace with a mounted TV, and elegant decor.",
      "link": "",
      "alt_text": "Living room with a sectional sofa, fireplace, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5bb28cf6-7ebb-47af-99ff-e4cf2acf6ab8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d3-410a-74f8-916e-13405fe8ed23.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white countertops, black appliances, and light gray cabinets.",
        "public_id": "019d02d3-410a-74f8-916e-13405fe8ed23",
        "storage_key": "property/6767906449166813/019d02d3-410a-74f8-916e-13405fe8ed23.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Discover a stylish and functional kitchen perfect for everyday living, featuring sleek cabinetry and modern appliances.",
      "link": "",
      "alt_text": "Modern kitchen with white countertops, black appliances, and light gray cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3fcffb94-80b4-4d85-9d9f-42821cd51d18",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d3-311d-745b-ad0c-f503d8b49d3b.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace and dining area",
        "public_id": "019d02d3-311d-745b-ad0c-f503d8b49d3b",
        "storage_key": "property/6767906449166813/019d02d3-311d-745b-ad0c-f503d8b49d3b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious living room with a cozy fireplace and a dedicated dining area, perfect for relaxing and entertaining guests.",
      "link": "",
      "alt_text": "Living room with a fireplace and dining area",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1c6fb6c0-996f-4292-977d-d1e4aefcb8e0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-0d8e-71bc-8b81-f33b7c6ce8f2.webp",
      "image_media": {
        "alt_text": "Bedroom with ensuite bathroom and walk-in closet.",
        "public_id": "019d02d2-0d8e-71bc-8b81-f33b7c6ce8f2",
        "storage_key": "property/6767906449166813/019d02d2-0d8e-71bc-8b81-f33b7c6ce8f2.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a comfortable bed, modern decor, and an en-suite bathroom accessible through a doorway. The room is bright and airy, with a large window and tasteful artwork.",
      "link": "",
      "alt_text": "Bedroom with ensuite bathroom and walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f33cf6a2-a489-4e74-8a86-731b6d734333",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019f387b-1f8c-757e-9005-edd619421269.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, seating, and view of pool area",
        "public_id": "019f387b-1f8c-757e-9005-edd619421269",
        "storage_key": "property/6767906449166813/019f387b-1f8c-757e-9005-edd619421269.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting lounge area, featuring a cozy stone fireplace, comfortable seating, and a scenic view of the outdoor pool.",
      "link": "",
      "alt_text": "Living room with fireplace, seating, and view of pool area",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dd3eff79-e066-4d52-8ea7-cd5ab6107df3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019f387b-0e2d-74fe-bed3-5ff38afc2faa.webp",
      "image_media": {
        "alt_text": "Outdoor built-in grill with black cabinets and stainless steel appliances.",
        "public_id": "019f387b-0e2d-74fe-bed3-5ff38afc2faa",
        "storage_key": "property/6767906449166813/019f387b-0e2d-74fe-bed3-5ff38afc2faa.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking with this modern built-in grill, featuring sleek black cabinetry and premium stainless steel appliances.",
      "link": "",
      "alt_text": "Outdoor built-in grill with black cabinets and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_88a38b17-24c3-4f62-a09c-56e9ce928a36",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019f387b-0b4e-7409-904b-20faefd29ea4.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment and a playground nearby.",
        "public_id": "019f387b-0b4e-7409-904b-20faefd29ea4",
        "storage_key": "property/6767906449166813/019f387b-0b4e-7409-904b-20faefd29ea4.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park with agility equipment, and let your kids have fun at the nearby playground.",
      "link": "",
      "alt_text": "Dog park with agility equipment and a playground nearby.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_046bb15b-26bc-4b4e-9a3e-8d70710d7c0d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019f387a-95a3-76ee-b220-5b2951728d29.webp",
      "image_media": {
        "alt_text": "Community lounge with a wet bar featuring a wine fridge, coffee maker, and seating, overlooking a swimming pool.",
        "public_id": "019f387a-95a3-76ee-b220-5b2951728d29",
        "storage_key": "property/6767906449166813/019f387a-95a3-76ee-b220-5b2951728d29.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy convenient amenities at our community lounge, featuring a wet bar perfect for entertaining and relaxation, with a sparkling swimming pool just steps away.",
      "link": "",
      "alt_text": "Community lounge with a wet bar featuring a wine fridge, coffee maker, and seating, overlooking a swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_354200f0-5bef-4e85-b74f-86be70c8881b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d3-877a-701f-bcfc-1938abd914f9.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables under umbrellas.",
        "public_id": "019d02d3-877a-701f-bcfc-1938abd914f9",
        "storage_key": "property/6767906449166813/019d02d3-877a-701f-bcfc-1938abd914f9.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling swimming pool, complete with comfortable lounge chairs and shaded seating areas.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and tables under umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_81f0e965-c19a-4852-b8ad-0d7ada2d4ce6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d3-7c64-722d-96aa-0fa03dd1e530.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building clubhouse with stone chimney and parking lot.",
        "public_id": "019d02d3-7c64-722d-96aa-0fa03dd1e530",
        "storage_key": "property/6767906449166813/019d02d3-7c64-722d-96aa-0fa03dd1e530.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Charming apartment building clubhouse with stone accents and lush landscaping. Features a welcoming entrance and nearby amenities.",
      "link": "",
      "alt_text": "Exterior view of apartment building clubhouse with stone chimney and parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1fe11eac-7a95-4df5-8453-eef69ed5c14c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-ec3c-7152-b7cb-7bfd39f465ab.webp",
      "image_media": {
        "alt_text": "Sundance apartment complex monument sign with landscaping and entrance.",
        "public_id": "019d02d2-ec3c-7152-b7cb-7bfd39f465ab",
        "storage_key": "property/6767906449166813/019d02d2-ec3c-7152-b7cb-7bfd39f465ab.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Welcome to Sundance apartments, featuring a prominent monument sign and beautifully landscaped grounds, leading to the community entrance.",
      "link": "",
      "alt_text": "Sundance apartment complex monument sign with landscaping and entrance.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ae707aa9-0fff-4aba-87ae-7380ea601ca5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-de6c-772a-a964-c7106da1f329.webp",
      "image_media": {
        "alt_text": "Building entrance with stone pillars and wooden beams.",
        "public_id": "019d02d2-de6c-772a-a964-c7106da1f329",
        "storage_key": "property/6767906449166813/019d02d2-de6c-772a-a964-c7106da1f329.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Welcome to the leasing office, featuring a charming entrance with natural wood accents and stone detailing.",
      "link": "",
      "alt_text": "Building entrance with stone pillars and wooden beams.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5413a92b-9369-41ce-b7bb-dbca17c853ba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-de37-725b-883b-b89ba57e737f.webp",
      "image_media": {
        "alt_text": "Outdoor hot tub with a covered seating area and table with chairs.",
        "public_id": "019d02d2-de37-725b-883b-b89ba57e737f",
        "storage_key": "property/6767906449166813/019d02d2-de37-725b-883b-b89ba57e737f.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and unwind in our outdoor hot tub, complete with a shaded seating area perfect for enjoying the fresh air.",
      "link": "",
      "alt_text": "Outdoor hot tub with a covered seating area and table with chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0fc7c497-c1f5-474b-a9bb-8ce63c7e88c9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-5fc2-739c-864b-3abcb68244b8.webp",
      "image_media": {
        "alt_text": "Office building entrance with a paved walkway and landscaping.",
        "public_id": "019d02d2-5fc2-739c-864b-3abcb68244b8",
        "storage_key": "property/6767906449166813/019d02d2-5fc2-739c-864b-3abcb68244b8.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Welcome to our community's office building, featuring a charming exterior with stone accents and a welcoming entrance.",
      "link": "",
      "alt_text": "Office building entrance with a paved walkway and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_593b9a14-02a1-4c0e-b3b5-eb741eef1ac2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-5709-7351-9597-e516a093f5d3.webp",
      "image_media": {
        "alt_text": "Carport parking and exterior of apartment buildings.",
        "public_id": "019d02d2-5709-7351-9597-e516a093f5d3",
        "storage_key": "property/6767906449166813/019d02d2-5709-7351-9597-e516a093f5d3.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Covered parking is available at this apartment community, providing protection from the elements for your vehicle.",
      "link": "",
      "alt_text": "Carport parking and exterior of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_31400a0e-81cf-4f35-9e39-718499b0a244",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "Farm 12 Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "B 3303 8th Ave SE, Puyallup, WA 98372, USA",
      "poi_short_description": "Farm-to-table fare, including seafood and burgers, served in an elegant setting.",
      "poi_long_description": "People say this restaurant serves delicious chicken salad sandwiches, wagyu pastrami sandwiches, and salmon bowls. They also highlight the cool atmosphere, beautiful outdoor seating, and friendly staff.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d3-0356-709b-95b3-859982c91050.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-0356-709b-95b3-859982c91050",
        "storage_key": "property/6767906449166813/019d02d3-0356-709b-95b3-859982c91050.webp",
        "width": 1080,
        "height": 770
      },
      "poi_business_url": "http://farm12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18392565969449683685&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "farm-12-restaurant",
      "poi_latitude": "47.1853014",
      "poi_longitude": "-122.2499863",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 253-697-9486",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-ca77-712d-bd8f-b26579389033.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-ca77-712d-bd8f-b26579389033",
        "storage_key": "property/6767906449166813/019d02d2-ca77-712d-bd8f-b26579389033.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg5TP2Wb7kFQR5Yr8HE2FP_8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_9a66416a-1ed7-4627-b6fe-6202ba84fc30",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "Dick's Drive-In",
      "poi_type": "Restaurants",
      "poi_address": "32048 Pacific Hwy S, Federal Way, WA 98003, USA",
      "poi_short_description": "Part of an old-school chain of fast-food spots offering burgers, fries & hand-dipped shakes.",
      "poi_long_description": "Diners say this hamburger restaurant serves delicious burgers, fries, and shakes, with many praising the fresh-cut fries and creamy milkshakes. They also highlight the fast and friendly service, affordable prices, and convenient location.\n\nSome reviews mention the fries can be greasy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d3-0323-754f-8744-98a2a19e3bb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-0323-754f-8744-98a2a19e3bb5",
        "storage_key": "property/6767906449166813/019d02d3-0323-754f-8744-98a2a19e3bb5.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "https://ddir.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4590813746551303815&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dicks-drive-in",
      "poi_latitude": "47.3138041",
      "poi_longitude": "-122.3128774",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 253-681-9995",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-ca77-712d-bd8f-b26579389033.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-ca77-712d-bd8f-b26579389033",
        "storage_key": "property/6767906449166813/019d02d2-ca77-712d-bd8f-b26579389033.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5wZ6I9VXkFQRh64rgcfYtT8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_b4e87d33-8af4-4cb8-a88d-037eddbd06a1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "32025 Pacific Hwy S, Federal Way, WA 98003, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves great chicken sandwiches, grilled chicken nuggets, and mac and cheese. They also highlight the friendly people, awesome atmosphere, and fast service.\n\nSome reviews mention that orders can be incorrect.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-7bed-778f-842a-8c5a04293fe7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-7bed-778f-842a-8c5a04293fe7",
        "storage_key": "property/6767906449166813/019d02d2-7bed-778f-842a-8c5a04293fe7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/wa/celebration-at-federal-way?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=10181381601793875107&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "47.3141898",
      "poi_longitude": "-122.3139968",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 206-429-2093",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-ca77-712d-bd8f-b26579389033.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-ca77-712d-bd8f-b26579389033",
        "storage_key": "property/6767906449166813/019d02d2-ca77-712d-bd8f-b26579389033.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJVVJ0XdXkFQRoxyfoZ-IS40",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_64394533-ae6a-46d7-942b-b5b52b5cfef9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "Yi's Traditional Korean Beef Soup",
      "poi_type": "Restaurants",
      "poi_address": "31248 Pacific Hwy S, Federal Way, WA 98003, USA",
      "poi_short_description": "Hefty portions of Korean comfort fare on offer in this modest, cozy eatery with Asian decor touches.",
      "poi_long_description": "People say this Korean restaurant serves delicious seolleongtang, a rich and comforting beef bone broth soup, and flavorful handmade dumplings. They highlight the authentic taste, the generous portions, and the fresh, homemade kimchi and radish kimchi. They also like the cozy and homey atmosphere, and the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d3-037d-70e9-a1bb-775b7b93451a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-037d-70e9-a1bb-775b7b93451a",
        "storage_key": "property/6767906449166813/019d02d3-037d-70e9-a1bb-775b7b93451a.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.yistraditional.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14087095060539390161&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "yis-traditional-korean-beef-soup",
      "poi_latitude": "47.32109519999999",
      "poi_longitude": "-122.3127034",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 253-946-1101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-ca77-712d-bd8f-b26579389033.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-ca77-712d-bd8f-b26579389033",
        "storage_key": "property/6767906449166813/019d02d2-ca77-712d-bd8f-b26579389033.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIwS3uXtXkFQR0TicKFJqf8M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "korean_restaurant"
    },
    {
      "id": "custom_155dcfe3-e92c-4de0-9b89-2ef508d070fe",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "Crockett's Public House",
      "poi_type": "Restaurants",
      "poi_address": "118 E Stewart Ave, Puyallup, WA 98371, USA",
      "poi_short_description": "Laid-back pub with stained-glass decorations & scratch-made American food from local ingredients.",
      "poi_long_description": "People say this restaurant serves delicious pork belly burnt ends, chicken and waffles, and seafood chowder. They also highlight the generous portions, friendly staff, and great atmosphere.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-834d-7538-9781-705081426444.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-834d-7538-9781-705081426444",
        "storage_key": "property/6767906449166813/019d02d2-834d-7538-9781-705081426444.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.crockettspublichouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5593536639592873914&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crocketts-public-house",
      "poi_latitude": "47.1927855",
      "poi_longitude": "-122.2927523",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 253-466-3075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-ca77-712d-bd8f-b26579389033.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-ca77-712d-bd8f-b26579389033",
        "storage_key": "property/6767906449166813/019d02d2-ca77-712d-bd8f-b26579389033.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJO5rzq6v-kFQRur8QGfA7oE0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_8909e9a9-5784-428b-b510-09a943417b80",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "The Outlet Collection Seattle",
      "poi_type": "Shopping & Retail",
      "poi_address": "1101 Outlet Collection Way, Auburn, WA 98001, USA",
      "poi_short_description": "Large outlet mall featuring brand-name shops for fashion & home goods, plus eateries & kid rides.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including major brands and outlets, with good deals and discounts. They also highlight the fun activities for kids, such as laser tag and a field house, and the convenient parking.\n\nOther reviews mention the food court can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-8397-7303-8b8a-5fdfc66e28cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-8397-7303-8b8a-5fdfc66e28cc",
        "storage_key": "property/6767906449166813/019d02d2-8397-7303-8b8a-5fdfc66e28cc.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://outletcollectionseattle.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17162083842743284899&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-outlet-collection-seattle",
      "poi_latitude": "47.2980791",
      "poi_longitude": "-122.243676",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 253-833-1790",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-ca37-7680-87c9-e936d98c1cdc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-ca37-7680-87c9-e936d98c1cdc",
        "storage_key": "property/6767906449166813/019d02d2-ca37-7680-87c9-e936d98c1cdc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZa-M3GBZkFQRozQvjFP4K-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_96cb78bc-c1cc-4a6e-afb5-b00369bf893c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "Emish Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2040 70th Ave E, Fife, WA 98424, USA",
      "poi_short_description": "Specialty store with Ukrainian groceries along with baked goods, meats and takeout dishes.",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, baked goods, and European specialties, including Ukrainian dishes like borscht and perogies. They highlight the delicious food, especially the sourdough bread, pastries, and lamb gyro, and the reasonable prices. They also like the welcoming atmosphere and friendly, helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-84c2-71d9-b222-5a11a2c52725.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-84c2-71d9-b222-5a11a2c52725",
        "storage_key": "property/6767906449166813/019d02d2-84c2-71d9-b222-5a11a2c52725.webp",
        "width": 1280,
        "height": 1004
      },
      "poi_business_url": "http://emishmarket.com/?utm_source=google&utm_medium=wix_google_business_profile&utm_campaign=6291644966344206943",
      "poi_directions_map_url": "https://maps.google.com/?cid=16631521818125547868&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "emish-market",
      "poi_latitude": "47.2387655",
      "poi_longitude": "-122.3368785",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 253-262-6070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-ca31-73de-abf5-14b75471097f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-ca31-73de-abf5-14b75471097f",
        "storage_key": "property/6767906449166813/019d02d2-ca31-73de-abf5-14b75471097f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyQZUtuf5kFQRXDmI2_kIz-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_95f70120-0392-43e5-93a4-650fd01b3364",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "H Mart",
      "poi_type": "Shopping & Retail",
      "poi_address": "31217 Pacific Hwy S, Federal Way, WA 98003, USA",
      "poi_short_description": "Large market stocking Asian groceries, including housewares, seafood and fresh produce.",
      "poi_long_description": "Shoppers say this Korean grocery store offers a wide variety of fresh produce, seafood, and Asian groceries, including kimchi, sauces, and ramen. They also highlight the friendly staff, clean environment, and convenient food court with delicious hot food options.\n\nSome reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-8465-76c6-a30e-9a2600b825c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-8465-76c6-a30e-9a2600b825c6",
        "storage_key": "property/6767906449166813/019d02d2-8465-76c6-a30e-9a2600b825c6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hmartus.com/federalway",
      "poi_directions_map_url": "https://maps.google.com/?cid=4688323470681939457&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "h-mart",
      "poi_latitude": "47.3218808",
      "poi_longitude": "-122.3152936",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 253-528-0500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-ca31-73de-abf5-14b75471097f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-ca31-73de-abf5-14b75471097f",
        "storage_key": "property/6767906449166813/019d02d2-ca31-73de-abf5-14b75471097f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo4-TAXtXkFQRAZ4fVltFEEE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_3268ec99-25f8-4e78-9d30-aa6e9153080d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "160 SW Campus Dr, Federal Way, WA 98003, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "People say this supermarket offers a wide selection of products, including fresh produce, bakery items, and a deli with pizza and campout chicken. They also highlight the low prices, great deals, and the friendly, helpful staff.\n\nSome reviews mention the store can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d3-0892-77fc-95e5-c70ecfdb32cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-0892-77fc-95e5-c70ecfdb32cb",
        "storage_key": "property/6767906449166813/019d02d3-0892-77fc-95e5-c70ecfdb32cb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6601844096944319406&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "47.292525",
      "poi_longitude": "-122.336179",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 253-838-7109",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-ca31-73de-abf5-14b75471097f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-ca31-73de-abf5-14b75471097f",
        "storage_key": "property/6767906449166813/019d02d2-ca31-73de-abf5-14b75471097f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0-CZObNXkFQRrivgZDp2nls",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_c6e26603-9f65-4c55-98bc-bed244e6563b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "1758 S 320th St, Federal Way, WA 98003, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide selection of unique and delicious foods, including fresh produce, packaged meals, and snacks. They highlight the reasonable prices, convenient location, and ample parking. They also like the friendly, helpful, and hardworking staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-8a4b-726f-9b50-7ede3fa36a21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-8a4b-726f-9b50-7ede3fa36a21",
        "storage_key": "property/6767906449166813/019d02d2-8a4b-726f-9b50-7ede3fa36a21.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/wa/federal-way/134/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=11390375309939476518&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "47.3169255",
      "poi_longitude": "-122.3109368",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 253-941-6138",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-ca31-73de-abf5-14b75471097f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-ca31-73de-abf5-14b75471097f",
        "storage_key": "property/6767906449166813/019d02d2-ca31-73de-abf5-14b75471097f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ22o423dXkFQRJohS3_69Ep4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_1cc4a6be-4742-4e44-b72b-2bf6890f8a99",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "Puyallup Public Library",
      "poi_type": "Education",
      "poi_address": "324 S Meridian, Puyallup, WA 98371, USA",
      "poi_short_description": "Welcoming library featuring events for kids, books, computers and a friendly staff.",
      "poi_long_description": "People say this public library offers a wide variety of media, including books, manga, magazines, comics, movies, and board games, and has a designated play area for kids. They highlight the library is large, clean, and organized, and has a nice teen area and a park outside. They also like the helpful, professional, and kind staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-8ad1-73f9-bc79-5e56d3282cd4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-8ad1-73f9-bc79-5e56d3282cd4",
        "storage_key": "property/6767906449166813/019d02d2-8ad1-73f9-bc79-5e56d3282cd4.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.puyalluplibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12452978426720017904&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "puyallup-public-library",
      "poi_latitude": "47.1895629",
      "poi_longitude": "-122.2954362",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 253-841-5454",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-ca31-73de-abf5-1b3790b86226.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-ca31-73de-abf5-1b3790b86226",
        "storage_key": "property/6767906449166813/019d02d2-ca31-73de-abf5-1b3790b86226.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJwz4I56n-kFQR8N0_gObd0aw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_119b7eff-3dfe-488a-91d1-bcb6920f782e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "Cascade Christian Schools - Junior High & High School Pioneer Campus",
      "poi_type": "Education",
      "poi_address": "811 21st St SE, Puyallup, WA 98372, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d3-09ed-76ac-9515-64410eca99e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-09ed-76ac-9515-64410eca99e2",
        "storage_key": "property/6767906449166813/019d02d3-09ed-76ac-9515-64410eca99e2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.cascadechristian.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6229204586665893585&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cascade-christian-schools---junior-high--high-school-pioneer-campus",
      "poi_latitude": "47.18431589999999",
      "poi_longitude": "-122.2644993",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 253-445-9706",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-ca31-73de-abf5-1b3790b86226.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-ca31-73de-abf5-1b3790b86226",
        "storage_key": "property/6767906449166813/019d02d2-ca31-73de-abf5-1b3790b86226.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU8ylrPH7kFQR0V50XZGUclY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_9da77192-8816-494d-95ac-17af33c17a9b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "Wild Waves Theme and Water Park",
      "poi_type": "Entertainment",
      "poi_address": "36201 Enchanted Pkwy S, Federal Way, WA 98003, USA",
      "poi_short_description": "Theme park with roller coasters & kid-friendly rides, plus a water area with pools & slides.",
      "poi_long_description": "People say this amusement park offers a variety of water rides, roller coasters, and kiddie rides, and that the season pass provides good value.\n\nOther reviews mention the lines can be long and some rides can be closed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d3-0ac8-776a-9319-a7addbc60d1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-0ac8-776a-9319-a7addbc60d1d",
        "storage_key": "property/6767906449166813/019d02d3-0ac8-776a-9319-a7addbc60d1d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.wildwaves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=120734302365377506&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wild-waves-theme-and-water-park",
      "poi_latitude": "47.2731529",
      "poi_longitude": "-122.3126059",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 253-661-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-cffc-7798-9fa8-61fdb20bbee1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-cffc-7798-9fa8-61fdb20bbee1",
        "storage_key": "property/6767906449166813/019d02d2-cffc-7798-9fa8-61fdb20bbee1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaVjyU9RXkFQR4mOxVDXvrAE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_b3164da8-70d1-40cc-9698-2231f2779f09",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "Pacific Bonsai Museum",
      "poi_type": "Entertainment",
      "poi_address": "2515 South 336th St, Federal Way, WA 98003, USA",
      "poi_short_description": "This collection boasts over 100 bonsai trees from China, Japan, Canada, Korea, Taiwan & America.",
      "poi_long_description": "People say this museum offers a stunning collection of bonsai trees, with informative plaques detailing their history and cultivation. They highlight the peaceful and tranquil atmosphere, and the easy access and well-maintained grounds. They also like the free admission and the option to donate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-91b2-70ab-89d3-bb0a2755c30a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-91b2-70ab-89d3-bb0a2755c30a",
        "storage_key": "property/6767906449166813/019d02d2-91b2-70ab-89d3-bb0a2755c30a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.pacificbonsaimuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4045163731685863932&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pacific-bonsai-museum",
      "poi_latitude": "47.29383379999999",
      "poi_longitude": "-122.3020013",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 253-353-7345",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-cfc1-7604-a203-7a533206ee73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-cfc1-7604-a203-7a533206ee73",
        "storage_key": "property/6767906449166813/019d02d2-cfc1-7604-a203-7a533206ee73.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6wDOE45XkFQR_PFtVftOIzg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_70b7fa9c-140a-4be8-9028-dffac69f7f30",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "Federal Way Memorial Field",
      "poi_type": "Entertainment",
      "poi_address": "1300 S 308th St, Federal Way, WA 98003, USA",
      "poi_short_description": "Stadium primarily used for track and field and football, with concessions and clean bathrooms.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d3-0d75-725e-b80d-34f596d53016.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-0d75-725e-b80d-34f596d53016",
        "storage_key": "property/6767906449166813/019d02d3-0d75-725e-b80d-34f596d53016.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.fwps.org/departments/athletics/contacts",
      "poi_directions_map_url": "https://maps.google.com/?cid=6511868263936655215&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "federal-way-memorial-field",
      "poi_latitude": "47.3275774",
      "poi_longitude": "-122.3170758",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 253-945-5575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-cfbe-724d-b8c5-e5bbf250c47c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-cfbe-724d-b8c5-e5bbf250c47c",
        "storage_key": "property/6767906449166813/019d02d2-cfbe-724d-b8c5-e5bbf250c47c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJuQhCiWRXkFQRb38VSK_NXlo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_c7cc90e7-b690-42fe-bd1c-b4f59991cde1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "Sparks Stadium",
      "poi_type": "Entertainment",
      "poi_address": "601 7th Ave SW, Puyallup, WA 98371, USA",
      "poi_short_description": "Covered stadium hosting football, soccer, and other high school sporting events.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.sparksstadium.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12567923058809807259&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sparks-stadium",
      "poi_latitude": "47.1873578",
      "poi_longitude": "-122.3003422",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 253-841-8785",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-cfbe-724d-b8c5-e5bbf250c47c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-cfbe-724d-b8c5-e5bbf250c47c",
        "storage_key": "property/6767906449166813/019d02d2-cfbe-724d-b8c5-e5bbf250c47c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAYZ7Bqj-kFQRm6HMLG87aq4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_809f134e-67d5-47e9-a1b4-9d55acb7a3fc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "Catapult Adventure Park Puyallup",
      "poi_type": "Entertainment",
      "poi_address": "1405 E Main Ave, Puyallup, WA 98372, USA",
      "poi_short_description": "Clean, kid-friendly park with bouncy castles, slides, arcades and an obstacle course.",
      "poi_long_description": "People say this amusement park offers a variety of fun activities for kids of different ages, including bounce houses and obstacle courses. They also highlight the spacious layout, which prevents overcrowding, and the helpful staff.\n\nSome reviews mention the massage chairs can be noisy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d3-0df8-7769-ae0a-a188d161fce0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-0df8-7769-ae0a-a188d161fce0",
        "storage_key": "property/6767906449166813/019d02d3-0df8-7769-ae0a-a188d161fce0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://catapultpuyallup.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18089286964889525687&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "catapult-adventure-park-puyallup",
      "poi_latitude": "47.19318699999999",
      "poi_longitude": "-122.2748637",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 253-466-3949",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-cffc-7798-9fa8-61fdb20bbee1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-cffc-7798-9fa8-61fdb20bbee1",
        "storage_key": "property/6767906449166813/019d02d2-cffc-7798-9fa8-61fdb20bbee1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtzn8by37kFQRtx1YRqcOCvs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_a3a62b3c-c4bb-4aa8-821d-6ecb36123142",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "35009 Enchanted Pkwy S, Federal Way, WA 98003, USA",
      "poi_short_description": "Spacious, clean athletic facility featuring a wide variety of equipment and classes, plus a pool.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-97ec-72de-937a-e8a1f4905ab2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-97ec-72de-937a-e8a1f4905ab2",
        "storage_key": "property/6767906449166813/019d02d2-97ec-72de-937a-e8a1f4905ab2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=325&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=18330114516273239084&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "47.2877945",
      "poi_longitude": "-122.315461",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 253-838-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-cffc-7798-9fa8-61fdb20bbee1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-cffc-7798-9fa8-61fdb20bbee1",
        "storage_key": "property/6767906449166813/019d02d2-cffc-7798-9fa8-61fdb20bbee1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe4MOHcZXkFQRLJSyEgmmYf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_06f6b078-9484-4f68-ab16-0852de210068",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "Fitness Quest MMA",
      "poi_type": "Health and Wellness",
      "poi_address": "1101 Outlet Collection Way #1275, Auburn, WA 98001, USA",
      "poi_short_description": "A full-service gym offering group classes and personal training alike.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d3-11f1-7777-a1e3-6024b1d347a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-11f1-7777-a1e3-6024b1d347a5",
        "storage_key": "property/6767906449166813/019d02d3-11f1-7777-a1e3-6024b1d347a5.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "https://fitness-quest-mma.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6673923412006407803&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fitness-quest-mma",
      "poi_latitude": "47.3000884",
      "poi_longitude": "-122.2443359",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 253-737-5829",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-cffc-7798-9fa8-61fdb20bbee1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-cffc-7798-9fa8-61fdb20bbee1",
        "storage_key": "property/6767906449166813/019d02d2-cffc-7798-9fa8-61fdb20bbee1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5badbBRZkFQRew7OtvuJnlw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_be14e46a-f9c5-4b0e-b5ad-f2864ea00255",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "Sumner Veterinary Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "16024 60th St E, Sumner, WA 98390, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d3-128a-750b-86e4-6bb5e6569655.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-128a-750b-86e4-6bb5e6569655",
        "storage_key": "property/6767906449166813/019d02d3-128a-750b-86e4-6bb5e6569655.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.sumnervet.com/?utm_source=gmb&utm_medium=organic&y_source=1_MTE2Njg4NjEtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10827785724690562959&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sumner-veterinary-hospital",
      "poi_latitude": "47.2022469",
      "poi_longitude": "-122.2148852",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 253-863-2258",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-cffc-7798-9fa8-61fdb20bbee1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-cffc-7798-9fa8-61fdb20bbee1",
        "storage_key": "property/6767906449166813/019d02d2-cffc-7798-9fa8-61fdb20bbee1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPwPO-TH6kFQRj_85oL8FRJY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_be4bd81a-8980-499f-824d-6cdec8b79215",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2800 Milton Way, Milton, WA 98354, USA",
      "poi_short_description": "Chain fitness center with tanning beds, showers, and modern equipment.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including weights, machines, and additional services like infrared treatments and hydro massages. They highlight the clean facilities, well-maintained equipment, and convenient amenities such as showers and a large parking lot. They also like the friendly, welcoming, and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d3-0f65-7009-b0b7-8cab2cbde1ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-0f65-7009-b0b7-8cab2cbde1ba",
        "storage_key": "property/6767906449166813/019d02d3-0f65-7009-b0b7-8cab2cbde1ba.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/milton-wa?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=1125001896294757161&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "47.2510152",
      "poi_longitude": "-122.2957753",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 253-292-3775",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-cffc-7798-9fa8-61fdb20bbee1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-cffc-7798-9fa8-61fdb20bbee1",
        "storage_key": "property/6767906449166813/019d02d2-cffc-7798-9fa8-61fdb20bbee1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwb7hBxn5kFQRKTNKoEPPnA8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_29e70798-f860-4108-83e3-4e742a9bb907",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "Ascend Gymnastics Auburn",
      "poi_type": "Health and Wellness",
      "poi_address": "1604 15th St SW #106, Auburn, WA 98001, USA",
      "poi_short_description": "Well-regarded for kids' classes and parties led by caring coaches, with recreational sessions too.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d3-1366-7398-a7d5-3f32584e59bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-1366-7398-a7d5-3f32584e59bb",
        "storage_key": "property/6767906449166813/019d02d3-1366-7398-a7d5-3f32584e59bb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://ascendgymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=667356088236210741&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ascend-gymnastics-auburn",
      "poi_latitude": "47.2952117",
      "poi_longitude": "-122.2519896",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 253-876-9991",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-ca31-73de-abf5-1b3790b86226.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-ca31-73de-abf5-1b3790b86226",
        "storage_key": "property/6767906449166813/019d02d2-ca31-73de-abf5-1b3790b86226.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqQVBrMBZkFQRNXoDktPsQgk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6ba0e898-d962-4d6b-97f0-85380c36b9da",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "Fitness Quest Puyallup",
      "poi_type": "Health and Wellness",
      "poi_address": "1710 E Main Ave, Puyallup, WA 98372, USA",
      "poi_short_description": "Sporty gym offering machines, equipment, strength training, and personal fitness trainers, as well as exercise classes.",
      "poi_long_description": "People say this gym offers a wide variety of machines, amenities like a sauna and turf area, and personal training. They highlight the affordable membership deals, the clean and well-maintained facilities, and the friendly and helpful staff. They also like the awesome group classes and the 24-hour access.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-a0a7-70ac-9982-89da448cdcba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-a0a7-70ac-9982-89da448cdcba",
        "storage_key": "property/6767906449166813/019d02d2-a0a7-70ac-9982-89da448cdcba.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://www.fitnessquest.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13571269912597709891&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fitness-quest-puyallup",
      "poi_latitude": "47.19144989999999",
      "poi_longitude": "-122.2704266",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 253-268-0625",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-cffc-7798-9fa8-61fdb20bbee1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-cffc-7798-9fa8-61fdb20bbee1",
        "storage_key": "property/6767906449166813/019d02d2-cffc-7798-9fa8-61fdb20bbee1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtQVTMav7kFQRQ0RV8xTWVrw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_250a80d0-8779-4507-b3dc-1fea10d8594d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "MultiCare Good Samaritan Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "401 15th Ave SE, Puyallup, WA 98372, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-a6fe-761b-bb6f-0cf434750b7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-a6fe-761b-bb6f-0cf434750b7e",
        "storage_key": "property/6767906449166813/019d02d2-a6fe-761b-bb6f-0cf434750b7e.webp",
        "width": 537,
        "height": 302
      },
      "poi_business_url": "https://www.multicare.org/location/good-samaritan-hospital/?utm_source=pg-google&utm_medium=organic&utm_campaign=pg-listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=636362443643242418&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "multicare-good-samaritan-hospital",
      "poi_latitude": "47.1786058",
      "poi_longitude": "-122.2898179",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 253-697-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-d083-7550-a190-c35302a71053.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-d083-7550-a190-c35302a71053",
        "storage_key": "property/6767906449166813/019d02d2-d083-7550-a190-c35302a71053.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJTSvuHBD8kFQRskfBWUXQ1Ag",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_bd2ad88f-1b93-49d5-b918-d836ccf5ecd5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "MultiCare Auburn Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "202 N Division St, Auburn, WA 98001, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d3-1616-7164-b130-6d9f8e39a4ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-1616-7164-b130-6d9f8e39a4ee",
        "storage_key": "property/6767906449166813/019d02d3-1616-7164-b130-6d9f8e39a4ee.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.multicare.org/location/auburn-medical-center/?utm_source=pg-google&utm_medium=organic&utm_campaign=pg-listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=11639181374272454319&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "multicare-auburn-medical-center",
      "poi_latitude": "47.3091229",
      "poi_longitude": "-122.2292207",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 253-833-7711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-d083-7550-a190-c35302a71053.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-d083-7550-a190-c35302a71053",
        "storage_key": "property/6767906449166813/019d02d2-d083-7550-a190-c35302a71053.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJfXuti29YkFQRrz7a-cqthqE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_80192dc3-c075-4ad3-b6c8-21ff92fdba9a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "Lake Tapps Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2022 198th Ave E, Bonney Lake, WA 98391, USA",
      "poi_short_description": "Waterside 80-acre park with a boat ramp, swimming facilities & picnic areas with grills.",
      "poi_long_description": "People say this park offers boating, swimming, and picnicking opportunities, and has a beautiful lake with clear water. They highlight the stunning views, especially of Mount Rainier, and the clean and well-maintained facilities, including restrooms and playgrounds. They also like the peaceful and relaxing vibe, and the presence of security.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d3-1775-75ac-9506-4a604e2931cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-1775-75ac-9506-4a604e2931cb",
        "storage_key": "property/6767906449166813/019d02d3-1775-75ac-9506-4a604e2931cb.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.co.pierce.wa.us/index.aspx?nid=1326",
      "poi_directions_map_url": "https://maps.google.com/?cid=11569821609542485329&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lake-tapps-park",
      "poi_latitude": "47.240238",
      "poi_longitude": "-122.1684644",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-d49b-7688-83f1-c40998e4ade1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-d49b-7688-83f1-c40998e4ade1",
        "storage_key": "property/6767906449166813/019d02d2-d49b-7688-83f1-c40998e4ade1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ55p2JUH3kFQRUQVrT3RDkKA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_656fc05b-5b2e-4357-877a-b6c16727bf87",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "Game Farm Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3030 R St SE, Auburn, WA 98002, USA",
      "poi_short_description": "Park with a playground & walking trail, plus facilities for softball, soccer, tennis & basketball.",
      "poi_long_description": "People say this park offers a variety of sports fields and courts, including soccer, baseball, tennis, and pickleball, as well as walking trails, a disc golf course, and river access. They highlight the new bridge connecting the park to a wilderness area, providing scenic views and extended exercise opportunities. They also like the well-lit tennis courts, which are open late, and the clean and well-maintained grounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d3-1857-7237-a2ea-332587ac04e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-1857-7237-a2ea-332587ac04e5",
        "storage_key": "property/6767906449166813/019d02d3-1857-7237-a2ea-332587ac04e5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12772272286572327046&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "game-farm-park",
      "poi_latitude": "47.2810232",
      "poi_longitude": "-122.2035778",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 253-931-3043",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-d49b-7688-83f1-c40998e4ade1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-d49b-7688-83f1-c40998e4ade1",
        "storage_key": "property/6767906449166813/019d02d2-d49b-7688-83f1-c40998e4ade1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZcXbyb73kFQRhrC1Z_k5QLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_57fcafaf-f9dd-4b29-b3da-0343d7999b3a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "Steel Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2410 S 312th St, Federal Way, WA 98003, USA",
      "poi_short_description": "This 52-acre, lakeside park offers a playground & volleyball pit, plus live summertime concerts.",
      "poi_long_description": "People say this city park offers a large playground, a lake with swimming and fishing, a dock, and picnic areas with grills. They highlight the park's spacious layout, beautiful natural surroundings, and family-friendly atmosphere. They also like the clean facilities, including bathrooms and a seasonal concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d3-1889-73a9-890c-063400dce767.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-1889-73a9-890c-063400dce767",
        "storage_key": "property/6767906449166813/019d02d3-1889-73a9-890c-063400dce767.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://cityoffederalway.com/page/community-parks-0",
      "poi_directions_map_url": "https://maps.google.com/?cid=11880846663345183193&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "steel-lake-park",
      "poi_latitude": "47.32237809999999",
      "poi_longitude": "-122.300183",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 253-835-6964",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-d49b-7688-83f1-c40998e4ade1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-d49b-7688-83f1-c40998e4ade1",
        "storage_key": "property/6767906449166813/019d02d2-d49b-7688-83f1-c40998e4ade1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJNY7k8tVZkFQR2RmTxxc_4aQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e67d6162-eb4a-488c-9a85-7e9d6483aa78",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "Celebration Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1095 South 324th St, Federal Way, WA 98003, USA",
      "poi_short_description": "Large public park with lighted baseball & soccer fields, plus a playground, picnic areas & trails.",
      "poi_long_description": "People say this city park offers multiple athletic fields, a playground, and hiking trails. They also highlight the park's connection to the BPA trail, ample parking, and clean, well-maintained facilities.\n\nOther reviews mention the playground can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d3-1af0-7279-a792-7b165ffde698.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-1af0-7279-a792-7b165ffde698",
        "storage_key": "property/6767906449166813/019d02d3-1af0-7279-a792-7b165ffde698.webp",
        "width": 1280,
        "height": 994
      },
      "poi_business_url": "https://www.federalwaywa.gov/page/our-parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=6934449869024769639&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "celebration-park",
      "poi_latitude": "47.3077102",
      "poi_longitude": "-122.3201244",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 253-835-6960",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-d49b-7688-83f1-c40998e4ade1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-d49b-7688-83f1-c40998e4ade1",
        "storage_key": "property/6767906449166813/019d02d2-d49b-7688-83f1-c40998e4ade1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJFRjHYZ9XkFQRZ7b5Y2odPGA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b929c5b1-e14e-40a9-afae-b0e7a7b74a0c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "Five Mile Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "36429 44th Ave S, Auburn, WA 98001, USA",
      "poi_short_description": "Lakeside place with a beach & fishing dock, plus a playground, baseball field & tennis courts.",
      "poi_long_description": "People say this park offers walking paths, picnic areas, a playground, a fishing dock, and a swimming area. They highlight the spaciousness, clean and well-maintained facilities, and the peaceful and relaxing atmosphere. They also like the ample parking and the availability of restrooms and showers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d3-1d38-751d-97c9-d613bad7c22e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-1d38-751d-97c9-d613bad7c22e",
        "storage_key": "property/6767906449166813/019d02d3-1d38-751d-97c9-d613bad7c22e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kingcounty.gov/services/parks-recreation/parks/parks-and-natural-lands/parksatoz.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=14235565840045125319&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "five-mile-lake-park",
      "poi_latitude": "47.2737253",
      "poi_longitude": "-122.2808475",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-477-6150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-d49b-7688-83f1-c40998e4ade1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-d49b-7688-83f1-c40998e4ade1",
        "storage_key": "property/6767906449166813/019d02d2-d49b-7688-83f1-c40998e4ade1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ8-NMgv4kFQRxy6TULXjjsU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c077a3d3-0023-4980-97aa-fcbb5105b20c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "Auburn Municipal Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2143 E St NE Suite 1, Auburn, WA 98002, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-b46f-7652-80ca-10e7dea40e5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-b46f-7652-80ca-10e7dea40e5a",
        "storage_key": "property/6767906449166813/019d02d2-b46f-7652-80ca-10e7dea40e5a.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://auburnmunicipalairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15666029001133359872&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "auburn-municipal-airport",
      "poi_latitude": "47.3261957",
      "poi_longitude": "-122.2242996",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 253-333-6821",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-d4b2-7353-bca6-70692c966b9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-d4b2-7353-bca6-70692c966b9c",
        "storage_key": "property/6767906449166813/019d02d2-d4b2-7353-bca6-70692c966b9c.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJxWoKJ_dYkFQRAIOF1V_qaNk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_948fd9da-4b3f-438b-89e8-f905ea6d7af3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "Auburn",
      "poi_type": "Transportation & Transit",
      "poi_address": "Auburn, WA 98001, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d3-1de2-7747-bf62-3f26827edab3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-1de2-7747-bf62-3f26827edab3",
        "storage_key": "property/6767906449166813/019d02d3-1de2-7747-bf62-3f26827edab3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.soundtransit.org/Rider-Guide/Auburn-Station",
      "poi_directions_map_url": "https://maps.google.com/?cid=1259782787896726413&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "auburn",
      "poi_latitude": "47.3065308",
      "poi_longitude": "-122.2320834",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-d555-746f-baab-d07600504c7d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-d555-746f-baab-d07600504c7d",
        "storage_key": "property/6767906449166813/019d02d2-d555-746f-baab-d07600504c7d.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJP1af5nFYkFQRjVO8XsWlexE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_0e970a0a-d46d-4082-a587-bfd42797f529",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "Puyallup",
      "poi_type": "Transportation & Transit",
      "poi_address": "Puyallup, WA 98371, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d3-1ff1-74c8-af5d-1e174ebbe968.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-1ff1-74c8-af5d-1e174ebbe968",
        "storage_key": "property/6767906449166813/019d02d3-1ff1-74c8-af5d-1e174ebbe968.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.soundtransit.org/Rider-Guide/Puyallup-Station",
      "poi_directions_map_url": "https://maps.google.com/?cid=6932385689825660565&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "puyallup",
      "poi_latitude": "47.1926175",
      "poi_longitude": "-122.295561",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-d555-746f-baab-d07600504c7d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-d555-746f-baab-d07600504c7d",
        "storage_key": "property/6767906449166813/019d02d2-d555-746f-baab-d07600504c7d.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJrWSlxKv-kFQRlU4POA7INGA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_6023ee69-3b37-4e6d-84c1-322ec027905a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "Sumner",
      "poi_type": "Transportation & Transit",
      "poi_address": "810 Maple St., Sumner, WA 98390, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d3-2137-74db-85d3-d6894ff82394.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-2137-74db-85d3-d6894ff82394",
        "storage_key": "property/6767906449166813/019d02d3-2137-74db-85d3-d6894ff82394.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.soundtransit.org/Rider-Guide/Sumner-Station",
      "poi_directions_map_url": "https://maps.google.com/?cid=15340170366867992869&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sumner",
      "poi_latitude": "47.2016551",
      "poi_longitude": "-122.2445703",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 800-201-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-d555-746f-baab-d07600504c7d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-d555-746f-baab-d07600504c7d",
        "storage_key": "property/6767906449166813/019d02d2-d555-746f-baab-d07600504c7d.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJrTveu9n7kFQRJfEjR6w749Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_60ccd8c7-f74b-4bfb-9bf8-447a0667a039",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "Federal Way Downtown",
      "poi_type": "Transportation & Transit",
      "poi_address": "Federal Way, WA 98003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d3-22e6-7715-ad83-c558e89bb586.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d3-22e6-7715-ad83-c558e89bb586",
        "storage_key": "property/6767906449166813/019d02d3-22e6-7715-ad83-c558e89bb586.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16353853400302073751&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "federal-way-downtown",
      "poi_latitude": "47.3159",
      "poi_longitude": "-122.30383",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-cffc-7798-9fa8-61fdb20bbee1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-cffc-7798-9fa8-61fdb20bbee1",
        "storage_key": "property/6767906449166813/019d02d2-cffc-7798-9fa8-61fdb20bbee1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIXQfGoJXkFQRl7fRaQWP9OI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_0630d143-17c6-4060-8670-4e4b7af251d2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "Boeing Building 17-70",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2400 Perimeter Rd, Auburn, WA 98001, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-be50-75b8-9d7b-8c9888db49da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-be50-75b8-9d7b-8c9888db49da",
        "storage_key": "property/6767906449166813/019d02d2-be50-75b8-9d7b-8c9888db49da.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4152677144536151503&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "boeing-building-17-70",
      "poi_latitude": "47.2882995",
      "poi_longitude": "-122.2422463",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 253-657-1270",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-cffc-7798-9fa8-61fdb20bbee1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-cffc-7798-9fa8-61fdb20bbee1",
        "storage_key": "property/6767906449166813/019d02d2-cffc-7798-9fa8-61fdb20bbee1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV_EMQPH3kFQRz_X1ctxFoTk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4aea5eea-9068-4ddb-a28e-815a417045f8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "DaVita Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3201 S 323rd St, Federal Way, WA 98001, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://davita.com/about/contact-us",
      "poi_directions_map_url": "https://maps.google.com/?cid=1368784550882395259&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "davita-corporate-office",
      "poi_latitude": "47.3113754",
      "poi_longitude": "-122.2929799",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 253-733-4602",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-cffc-7798-9fa8-61fdb20bbee1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-cffc-7798-9fa8-61fdb20bbee1",
        "storage_key": "property/6767906449166813/019d02d2-cffc-7798-9fa8-61fdb20bbee1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy6Zz9oZXkFQRe0RjAUzm_hI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7e93a77b-80f8-4281-a3e3-59e185395aed",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "REI Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1700 45th St E, Sumner, WA 98352, USA",
      "poi_short_description": "Retail chain carrying gear, apparel & footwear for a wide range of outdoor & fitness activities.",
      "poi_long_description": "Retail chain carrying gear, apparel & footwear for a wide range of outdoor & fitness activities.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.rei.com/?y_source=1_MTQ1MzQ2OC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=11430655182386199918&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rei-headquarters",
      "poi_latitude": "47.2161801",
      "poi_longitude": "-122.231871",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 425-300-3003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-cffc-7798-9fa8-61fdb20bbee1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-cffc-7798-9fa8-61fdb20bbee1",
        "storage_key": "property/6767906449166813/019d02d2-cffc-7798-9fa8-61fdb20bbee1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu86iMfVbkFQRbn0bgFPYoZ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_8f14bd50-2b3b-4c65-83fe-565421420a8b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "Federal Way City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "33325 8th Ave S, Federal Way, WA 98003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.cityoffederalway.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12254893830259000528&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "federal-way-city-hall",
      "poi_latitude": "47.3040068",
      "poi_longitude": "-122.32649",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 253-835-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-d646-730f-a9f2-3bfb0b2a793b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-d646-730f-a9f2-3bfb0b2a793b",
        "storage_key": "property/6767906449166813/019d02d2-d646-730f-a9f2-3bfb0b2a793b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWYCoHKRXkFQR0MS2aAIhEqo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_a68b9f12-8e60-4f8a-b2bd-2e359a44c591",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "poi_name": "City of Auburn",
      "poi_type": "Major Employers & Offices",
      "poi_address": "25 W Main St, Auburn, WA 98001, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.auburnwa.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1561191381570175437&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-auburn",
      "poi_latitude": "47.3078503",
      "poi_longitude": "-122.2300859",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 253-931-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d2-d646-730f-a9f2-3bfb0b2a793b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-d646-730f-a9f2-3bfb0b2a793b",
        "storage_key": "property/6767906449166813/019d02d2-d646-730f-a9f2-3bfb0b2a793b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ64ls0G9YkFQRzUHkPEp3qhU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    }
  ],
  "office_hours": [
    {
      "id": "custom_1fe9b63d-b266-4504-9791-929d14bd0f6c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_059dad47-81bb-4b97-b42d-ece53e6ecab9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_519cafb2-912c-4c17-ae7c-d1392b8faac7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_ca72c657-58cf-4716-b2ed-4a5f0b204ea3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_fab595c9-aaa2-4663-b09a-b719c9ccac25",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_a113a540-7c62-443c-b349-6dcb09f3bcc8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "rating": "5.0",
      "name": "Vicki Murdoch",
      "text": "I’ve loved living here knowing how management takes pride in making Sundance a class act to live. The new management staff has made significant changes which has made a positive impact. Keep up the good work",
      "date": "2025-08-22",
      "title": ""
    },
    {
      "id": "custom_0d923287-f243-4097-bf2b-bffd407bf1d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "rating": "5.0",
      "name": "Charles Sandoval",
      "text": "My husband and I enjoy living at Sundance Apartments. Today we went to the pool party, and while the weather was cold, rainy, and dreary outside; the welcome inside the office was sunny and bright! :) Liberty Joy is the office manager. We just met her today in person, and must say she is kind, personable, and professional. We feel we are in good hands with her. The property is well kept. While we have not had a need to call on maintenance yet; we did meet, Daniel who was also very kind and personable. No complaints here! :) :)",
      "date": "2024-06-15",
      "title": ""
    },
    {
      "id": "custom_d6354069-263c-4e93-9167-5fa7c0906ed9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "rating": "5.0",
      "name": "Malik Mayeux",
      "text": "The maintenance team does a a great job of completing and communicating work orders that I have a recently put in. Thank you!",
      "date": "2025-07-12",
      "title": ""
    },
    {
      "id": "custom_05cc969b-4caa-446a-8f38-0d2012b75afb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "rating": "5",
      "name": "David Giessen",
      "text": "This is a compliment to the staff ar Sundance . They are very efficient and quick to repair the problems you have. I want to say thank you for your prompt attention to repairs.",
      "date": "2026-09-25",
      "title": "false"
    },
    {
      "id": "custom_c32dcc36-4a74-4030-bec1-8e5a77061ba8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "rating": "5",
      "name": "Erika S",
      "text": "Sundance Apartments is definitely a place you can call home! They offer so many great amenities, including a newly upgraded gym, a dog park, and a pool with a hot tub. I also love having an in-unit washer and dryer which saves me a trip to the laundromat.\n\nThe community gate is up and running now as well, which gives me an added sense of security and makes me feel a little safer. And to top it all off, the staff here are just as exceptional. They’re friendly, helpful, and make the community feel even more welcoming.\n\nOverall, I’m really happy to call Sundance Apartments home! ❤️\n",
      "date": "2026-09-15",
      "title": "false"
    },
    {
      "id": "custom_5f9eaecb-409f-4ae3-973f-4da7c368b345",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "rating": "5",
      "name": "Rachel Cade-Williams",
      "text": "Maintenance was knowledgeable and friendly.",
      "date": "2026-06-05",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_544c26de-fd5b-4bea-8798-8ede3b3e5dbc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d20b7-fdc3-7663-9bdf-3432f2897288.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with white cabinets, black appliances, and a breakfast bar.",
        "public_id": "019d20b7-fdc3-7663-9bdf-3432f2897288",
        "storage_key": "property/6767906449166813/019d20b7-fdc3-7663-9bdf-3432f2897288.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "The Enchanted- 2 bedroom x 1 bathroom",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=c36gHUrwmtM"
    },
    {
      "id": "custom_f4065860-06da-4fd4-9335-7351ef5f1209",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d20b7-fdc3-7663-9bdf-3a953ea4f354.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Spacious living area with a fireplace and a large window.",
        "public_id": "019d20b7-fdc3-7663-9bdf-3a953ea4f354",
        "storage_key": "property/6767906449166813/019d20b7-fdc3-7663-9bdf-3a953ea4f354.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "The Rainier- 3 bedroom x 2 bathroom",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=mE824aExVNS"
    },
    {
      "id": "custom_cca4dd63-4fd1-4b08-ac38-445d77284005",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166813/019d02d3-d14c-7278-b190-5fba711e797f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Spacious living room with a modern fireplace and large windows leading to a patio.",
        "public_id": "019d02d3-d14c-7278-b190-5fba711e797f",
        "storage_key": "property/6767906449166813/019d02d3-d14c-7278-b190-5fba711e797f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "The Firwood- 1 bedroom x 1 bathroom",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=XnawjahcGA9"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019fa8f8-3214-71b0-8a42-9da0436f3882",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Sundance Website",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "generator",
      "page_item_url": "sundance-apartments-pool-milton-wa",
      "search_query": "sundance apartments with pool Milton WA",
      "category": "Amenity",
      "h1_title": "Sundance Apartments with Pool",
      "h2_subtitle": "Discover relaxation and comfort at Sundance Apartments. Enjoy access to our serene pool in Milton, WA, and enhance your lifestyle.",
      "page_copy": "Nestled in the heart of Milton, WA, Sundance Apartments offers residents an unparalleled living experience. Imagine spending sun-kissed days relaxing by our stunning pool, a perfect oasis for unwinding after a busy day. Whether you're looking to take a refreshing dip or just lounge with a good book, our pool is conveniently accessible for all our residents.\n\nBeyond the pool, Sundance boasts a variety of upscale amenities designed to enhance your daily life. Enjoy meals in our charming dining room or cozy up by the fireplace in the cooler months. Each apartment also features a private patio, providing a personal outdoor retreat. Experience the perfect blend of comfort and convenience at Sundance Apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Sundance Apartments with Pool in Milton, WA",
      "seo_description": "Explore Sundance Apartments in Milton, WA, featuring a refreshing pool and upscale amenities for a luxurious lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-pierce-county",
      "search_query": "dog-friendly apartments near Pierce County",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments in Pierce County",
      "h2_subtitle": "Enjoy living at Sundance Apartments, where pets are part of the family. Located near Pierce County, we welcome your furry friends with open arms.",
      "page_copy": "Sundance Apartments, located in the vibrant area of Milton, WA, is a haven for pet-lovers searching for dog-friendly apartments near Pierce County. We proudly welcome your furry companions, offering pet-friendly amenities and a community that appreciates all family members, including those with four legs. Our spacious layouts and private patios provide ample room for your pets to roam and enjoy.\n\nBeyond pet-friendliness, Sundance Apartments offers an array of amenities such as a cozy fireplace and a dining room perfect for hosting dinners with friends. Our location near Pierce County gives you easy access to scenic parks and trails, perfect for long walks with your dog. Experience the warmth and community of Sundance Apartments while providing a loving home for you and your pet.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments near Pierce County",
      "seo_description": "Discover dog-friendly living at Sundance Apartments near Pierce County. Perfect for pet owners seeking a welcoming and comfortable community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "generator",
      "page_item_url": "milton-wa-apartments-in-unit-laundry",
      "search_query": "Milton WA apartments with in-unit laundry",
      "category": "Amenity",
      "h1_title": "Milton WA Apts with In-Unit Laundry",
      "h2_subtitle": "Discover the convenience of in-unit laundry at Sundance Apartments in Milton, WA. Experience hassle-free living today!",
      "page_copy": "At Sundance Apartments in Milton, WA, we understand the importance of convenience and comfort in your home. Our spacious apartments come equipped with in-unit laundry facilities, making everyday chores a breeze. No more trips back and forth to the laundromat; you can enjoy the luxury of washing and drying in the comfort of your home.\n\nSundance Apartments offer more than just in-unit laundry. With amenities like a relaxing spa, inviting dining room, and private patios, we cater to a modern and comfortable lifestyle. Located in the heart of Milton, WA, you'll have easy access to local dining and attractions while enjoying the tranquility of our community. Choose Sundance Apartments for a blend of convenience and style.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Milton WA Apartments with In-Unit Laundry",
      "seo_description": "Experience the convenience of in-unit laundry at Sundance Apartments in Milton, WA. Enjoy hassle-free living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "generator",
      "page_item_url": "luxury-apartments-fitness-center-98354",
      "search_query": "luxury apartments with fitness center 98354",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Fitness Center",
      "h2_subtitle": "Elevate your lifestyle at Sundance Apartments in zip code 98354. Enjoy our state-of-the-art fitness center and more luxury amenities.",
      "page_copy": "Located in the 98354 area, Sundance Apartments offers a luxurious living experience complete with a state-of-the-art fitness center. Whether you're a fitness enthusiast or just getting started on your wellness journey, our fully-equipped gym makes it easy to stay active and healthy right at home. Enjoy the convenience of working out any time that fits your schedule.\n\nIn addition to our premium fitness center, residents at Sundance can enjoy elegant living spaces with features such as cozy fireplaces and private patios. The on-site dining room is perfect for entertaining, and the tranquil spa offers a retreat from daily stress. Positioned in the heart of Milton, WA, Sundance Apartments blends comfort, style, and convenience. Discover upscale living today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Fitness Center 98354",
      "seo_description": "Experience luxury living with a fitness center at Sundance Apartments in the 98354 area. Perfect for those seeking upscale amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "generator",
      "page_item_url": "apartments-walk-in-closets-milton",
      "search_query": "apartments with walk-in closets in Milton",
      "category": "Amenity",
      "h1_title": "Milton Apartments with Walk-In Closets",
      "h2_subtitle": "Discover spacious living at Sundance Apartments in Milton. Our walk-in closets offer abundant storage for your lifestyle needs.",
      "page_copy": "Sundance Apartments in Milton redefines spacious living with its impressive walk-in closets. If you're searching for apartments with walk-in closets in Milton, look no further. Our large closets provide ample storage, keeping your living space organized and clutter-free. Whether you have an extensive wardrobe or need extra space for your belongings, our closets are designed with your convenience in mind.\n\nBeyond generous storage, Sundance Apartments offers an array of desirable features including a cozy fireplace for chilly evenings and a dining room perfect for gatherings with friends or family. Enjoy the serenity of a private patio and relax in our inviting spa. Situated in a convenient Milton location, Sundance Apartments offers both comfort and functionality for your everyday life.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Walk-In Closets in Milton",
      "seo_description": "Find your perfect home with walk-in closets at Sundance Apartments in Milton. Experience spacious living and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-milton-wa",
      "search_query": "one bedroom apartments milton wa",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Milton WA",
      "h2_subtitle": "Explore comfortable one bedroom living at Sundance Apartments in Milton, WA. Perfectly designed for modern lifestyles.",
      "page_copy": "Discover the perfect blend of comfort and style at Sundance Apartments, where our one bedroom apartments in Milton, WA offer a practical and peaceful living environment. Our well-designed spaces are ideal for individuals or couples seeking a cozy retreat. Each apartment features modern amenities including a beautiful fireplace and a private patio, ideal for relaxing after a long day.\n\nSituated in a prime location, Sundance Apartments ensures you're never far from what matters. Enjoy in-unit laundry for convenience, and take advantage of our dining room for hosting gatherings. The Milton area is rich in local attractions and dining, providing a vibrant community atmosphere. Choose Sundance Apartments for a one bedroom home that complements your lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Milton WA",
      "seo_description": "Find comfortable one bedroom apartments at Sundance in Milton, WA. Designed for modern living with full amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "generator",
      "page_item_url": "two-bedroom-floorplans-pierce-county",
      "search_query": "two bedroom floorplans pierce county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Floorplans in Pierce County",
      "h2_subtitle": "Explore spacious two bedroom floorplans at Sundance Apartments, located in the heart of Pierce County. Perfect for roommates or small families.",
      "page_copy": "Sundance Apartments offers thoughtfully designed two bedroom floorplans that cater to a variety of living arrangements in Pierce County. Whether you're sharing with a roommate or need extra space for a home office, these residences provide both privacy and comfort. Each apartment includes desirable features such as a cozy fireplace, ideal for relaxing evenings, and a private patio to enjoy the outdoors.\n\nNestled in a prime area of Milton, our community is rich with amenities. Residents enjoy access to a serene spa, a convenient on-site dining room, and more. The neighborhood provides easy access to shops and local dining, making Sundance Apartments a sought-after living destination. Discover the ideal blend of convenience and luxury with our two bedroom floorplans in Pierce County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Floorplans Pierce County",
      "seo_description": "Discover spacious two bedroom floorplans at Sundance Apartments in Pierce County. Perfect for those seeking comfort and versatility.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166813",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-98354",
      "search_query": "three bedroom apartments near 98354",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 98354",
      "h2_subtitle": "Find spacious three bedroom living at Sundance Apartments, conveniently located near the 98354 area. Perfect for families and roommates.",
      "page_copy": "For those seeking ample living space near the 98354 area, Sundance Apartments offers exceptional three bedroom apartments tailored to your needs. Our spacious layouts provide the perfect blend of functionality and style, making them ideal for families or roommates looking for a harmonious living environment. Each apartment boasts modern amenities, including a dining room for family meals and a cozy fireplace to create a warm ambiance.\n\nConveniently situated in Milton, residents of Sundance Apartments enjoy easy access to local attractions and community amenities like a rejuvenating spa and private patios. With plenty of room to grow and enjoy, our three bedroom apartments near 98354 provide both comfort and convenience, ensuring that you have everything you need for a vibrant lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 98354",
      "seo_description": "Explore spacious three bedroom apartments at Sundance, located near the 98354 area. Ideal for families and roommates.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "lindseye@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6013"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10714990798"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PHMFHCGB"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Pathfinder 2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Pathfinder Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "176SUD"
    },
    {
      "ID": "custom_anyonehome_chatbot",
      "type": "STRING",
      "value": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('MRW5jXpan5npCnJXTA')</script>"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "2756601004"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/d7p1x5k8vkx"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "22009716"
    },
    {
      "ID": "custom_website_tracking_email",
      "type": "STRING",
      "value": "amc_sundance_propertywebsite@leads.anyonehome.com"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC LLC/Sundance/scheduletourwidget/B7DLwrhryVWc6uetbG/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjJVVmJZZ0xDaU51dnVDTWs4WjAxTlE9PSIsInZhbHVlIjoiUzBHZmVpMmJpVUVQbng0a25ZN0REQT09IiwibWFjIjoiZjU3NDM5ZDk5NmQ0ZDIwMTY0NzQxYWZhNTBkMzZhMTEzZWI3YjAxNzZlN2EyODY1OTE0MWUzYjAzN2QyOGZhMyJ9"
    }
  ],
  "custom_csm": "lindseye@repli360.com",
  "custom_qb_id": "6013",
  "custom_repli_id": "10714990798",
  "custom_google_gtm_id": "GTM-PHMFHCGB",
  "custom_rollout_phase": "Pathfinder 2",
  "custom_vibesites_theme": "Pathfinder Preferred",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "full_stack",
  "custom_aim_property_code": "176SUD",
  "custom_anyonehome_chatbot": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('MRW5jXpan5npCnJXTA')</script>",
  "custom_hubspot_company_id": "2756601004",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/d7p1x5k8vkx",
  "custom_website_subscription": "turnkey",
  "custom_broker_license_number": "22009716",
  "custom_website_tracking_email": "amc_sundance_propertywebsite@leads.anyonehome.com",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC LLC/Sundance/scheduletourwidget/B7DLwrhryVWc6uetbG/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjJVVmJZZ0xDaU51dnVDTWs4WjAxTlE9PSIsInZhbHVlIjoiUzBHZmVpMmJpVUVQbng0a25ZN0REQT09IiwibWFjIjoiZjU3NDM5ZDk5NmQ0ZDIwMTY0NzQxYWZhNTBkMzZhMTEzZWI3YjAxNzZlN2EyODY1OTE0MWUzYjAzN2QyOGZhMyJ9",
  "custom_audioeye_site_id": "c23d0932-4f2e-42c9-8df4-860d4c713344",
  "custom_audioeye_site_hash": "9b6d0a801d067418df91cac8020dd00e"
};

export const generatedAt = '2026-10-08T21:34:03.539Z';
